import React, { useState } from "react";
import { HiOutlineArrowLeft } from "react-icons/hi2";
import ScrollableContainer from "./ScrollableContainer";
import BackButton from "./BackButton";
import LoyaltyEmailLogin from "../../molecules/LoyaltyEmailLogin";
import LmcUserViewForgotPassword from "../../pages/lmcUserVIew/LmcUserViewForgotPassword";
import LanguageSelector from "../LanguageSelector";

interface EmailAuthViewProps {
  onBack: () => void;
  onLoginSuccess: () => void;
  t: (key: string, options?: Record<string, unknown>) => string;
}

const EmailAuthView: React.FC<EmailAuthViewProps> = ({
  onBack,
  onLoginSuccess,
  t,
}) => {
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  if (showForgotPassword) {
    return (
      <ScrollableContainer>
        <div className="flex items-start justify-between gap-2 mb-2">
          <div>
            <h3 className="text-lg font-semibold text-white">{t("key57")}</h3>
            <p className="text-sm text-white/70 leading-relaxed mt-1">
              {t("key66")}
            </p>
          </div>
          <button
            type="button"
            onClick={() => setShowForgotPassword(false)}
            className="p-2 rounded-full bg-white/10 border border-white/15 text-white hover:bg-white/20 transition"
          >
            <HiOutlineArrowLeft className="w-5 h-5" />
          </button>
        </div>

        <LmcUserViewForgotPassword />
      </ScrollableContainer>
    );
  }

  return (
    <ScrollableContainer>
      <div className="flex items-start justify-between gap-2">
        <div>
          <h2 className="text-lg font-semibold text-white">{t("key25")}</h2>
        </div>
        <div className="flex items-center gap-2">
          <BackButton onClick={onBack} label={t("event.auth.backToTickets")} />
          <LanguageSelector variant="compact" />
        </div>
      </div>

      <div className="flex-1 flex flex-col gap-4">
        <LoyaltyEmailLogin
          onLoginSuccess={onLoginSuccess}
          onForgotPassword={() => setShowForgotPassword(true)}
        />
      </div>
    </ScrollableContainer>
  );
};

export default EmailAuthView;
